import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import t from '@sprinx/translate/translate';
import usePreferredLocale from '../usePreferredLocale';
export default function useTranslate() {
  var trRef = React.useRef();
  var locale = usePreferredLocale();
  return function (path, options) {
    if (typeof path !== 'string') return t(path, options);
    var key = JSON.stringify({
      path: path,
      options: options,
      locale: locale
    }); // istanbul ignore next

    if (!trRef.current) {
      trRef.current = {};
    } // istanbul ignore next


    if (!trRef.current[key]) {
      trRef.current[key] = t(path, _extends({
        locale: locale
      }, options));
    }

    return trRef.current[key];
  };
}